module.exports = __webpack_public_path__ + "static/media/testing.040bd7e9.png";